import React, {memo, useContext} from 'react';

import {LocaleContext} from '@pb/kit-context-locale';
import {INTEGER} from '@pb/kit-formatters';
import {getWidthOfText} from '@pb/kit-util-get-width-of-text';

import {rowNumbered} from './row-numbered.module.styl';

import type {LocaleContextType} from '@pb/kit-context-locale';
import type {ReactNode} from 'react';

type Props = {
    maxRowNumber: number,
    rowNumber?: number,
    placeholder?: ReactNode,
};

export const RowNumbered = memo<Props>(props => {
    const {rowNumber = 0, maxRowNumber, placeholder = null} = props;
    const {locale} = useContext<LocaleContextType>(LocaleContext);
    const width = getWidthOfText(INTEGER.format(maxRowNumber, locale), {fontSize: 12});

    return (
        <div style={{width, minWidth: width}} className={rowNumbered}>
            {placeholder || INTEGER.format(rowNumber, locale)}
        </div>
    );
});

